import tpl from './developLogs.html';
import "./developLogs.css";

class DevelopLogs {
    constructor(container, opts) {
        this.container = container;
        this.container.innerHTML = tpl;
    }
}

export {
    DevelopLogs
}